import React from "react";

const ForgotPasswordSent = () => {
  return (
    <div>
      <h2 className="gkit-h2">Request a new password</h2>
      <p className="gkit-p-20 gkit-light">
        A password reset link has been sent to your email address. Please make
        sure to check your spam folder.
      </p>
      <a href="/" className="gkit-btn gkit-primary gkit-btn-md mt-3 mb-5">
        Login
      </a>
      <p className="gkit-p-17 mb-1">Can't find the email? </p>
      <a
        className="gkit-p-17 text-decoration-none fw-bold gkit-link"
        href="/auth/forgot-password"
      >
        Click here to try again.
      </a>
    </div>
  );
};

export default ForgotPasswordSent;
